import Header from "./components/Header";
import TopTicker from "./components/TopTicker";
import StationHero from "./components/StationHero";
import DockEntries from "./components/DockEntries";
import LiveFeed from "./components/LiveFeed";
import HotRank from "./components/HotRank";
import ZoneArchive from "./components/ZoneArchive";
import DeepArchive from "./components/DeepArchive";
import AccessCta from "./components/AccessCta";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div id="top" className="min-h-screen bg-background-50">
      <TopTicker />
      <Header />
      <main>
        <StationHero />
        <DockEntries />
        <LiveFeed />
        <HotRank />
        <ZoneArchive />
        <DeepArchive />
        <AccessCta />
      </main>
      <Footer />
    </div>
  );
}